import { ChangeEvent, FormEvent, ReactElement, ReactNode } from "react";
import { IComboBoxOption, IDropdownOption,IComboBox } from "@fluentui/react";
import { Slot } from "@fluentui/react-components";


export interface Ifilter {
  skip: number;
  take: number;
  search?: string | null;
}
export interface IPaginacion {
  total: number;
  page: number;
  pages: number;
}
export interface IPaginacionComponent {
  onChangeTake?: (take: number) => void;
  onChangeSkip?: (skip: number) => void;
  totalPagesPagination?: number;
  skipPagination?: number;
  takePagination?: number;
  isLoading?: boolean;
  total?: number;
  cantidad?: number;
  actualPage?:number;
  isVisible:boolean

}

export interface IFilterChecklistMantenimiento {
  equipoModeloId?: string | null;
  tipoEquipoId?: string | null;
  equipoId?: string | null;
  estadoId?: string | null;
  fecha?: string | null;
  fechaFin?: string | null;
  SoloCriticas?: boolean;
}

export interface IFilterIpercHistorial {
  actividadId?: string | null;
  estadoId?: string | null;
  fechaInicio?: string | null;
  fechaFin?: string | null;
  supervisorId?: string | null;
  equipoId?: string | null;
}
export const InitialFilter: Ifilter = {
  skip: 0,
  take: 50,
  search: "",
};

export interface IColumn {
  key: any;
  name: string | ReactNode;
  fieldName?: string;
  minWidth?: number | string;
  maxWidth?: number | string;
  status?:boolean;
  onRender?: (item: any, indexItem: number) => ReactNode;
  columns?: IColumn[],
  isResizable?:boolean,   
  isCollapsible?:boolean,     
  isPadded?:boolean,
  isMultiline?:boolean,
}
export interface IButtonGroup {
  // icon?:JSX.Element;
  icon?: Slot<"span">;
  text: string | any;
  type?: "primary" | "outline" | "subtle" | "transparent";
  background?: string;
  onClick?: () => void;
  description?: string | ReactNode;
  defaultValue?: string;
  color?: string;
  disable?: boolean
  disabled?: boolean
}
export interface IButtonsGroupTabla {
  isSearch?: boolean;
  placeholder?: string;
  leftButtons?: IButtonGroup[];
  comboOptions?: IComboBoxOption[];
  defaultSelectedOptions?: IComboBoxOption[]
  onSelectCombo?: ( event: React.FormEvent<IComboBox>, option?: IComboBoxOption | undefined) => void;
  rightButton?: IButtonGroup[];
  rightText?: string | ReactElement;
  value?: string;
  onChangeSearch?: (
    event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined
  ) => void;
  // onChangeSearch?: (
  //   event: ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLSpanElement>,
  //   data: InputOnChangeData
  // ) => void;
  onEnterTextBox?: () => void;
}
